<template>
  <div class="p-2 bg-gray-50 rounded-md shadow-sm">
    <div class="flex flex-col mb-2">
      <span>
        User Management Change Editor
      </span>
    </div>
    <div class="rounded-md p-2 mb-2 bg-red-200 border-2 border-red-500 shadow-md"
      v-if="errorsMap !== undefined && showErrorSection">
      <div class="rounded-md p-2 bg-gray-200">
        <div>
          <XButton class="p-1 mr-2 w-6 h-6"
            @click="closeErrorSection">
          </XButton>
          <span class="font-bold text-red-600">Errors</span>
        </div>
        <div class="p-2 rounded-md gap-2">
          <div class="flex flex-col"
            v-for="(errors, key) in errorsMap"
            :key="key">
            <div class="flex flex-row"
              v-for="error in errors"
              :key="error">
              <span class="text-gray-400 pr-2">{{ key }}.</span>
              <span class="text-red-800">{{ error }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <textarea class="w-full h-48 text-sm rounded-md !border border-gray-300 outline-none text-md px-3 py-2 placeholder-gray-400 disabled:bg-gray-100"
      :class="{
        'resize-y': resizable,
        'resize-none': !resizable,
      }"
      v-model="formValues"
      :disabled="disabled"
    />
  </div>
</template>

<script>
import XButton from '../XButton.vue'

export default {
  components: {
    XButton,
  },
  props: {
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    resizable: {
      type: Boolean,
      default: false,
    },
    value: undefined,
    defaultValue: {
      type: String,
      default: undefined,
    },
    errorsMap: {
      type: Object,
      default: undefined,
    }
  },
  data() {
    return {
      formValues: undefined,

      showErrorSection: false,
    }
  },
  mounted() {
    this.formValues = this.defaultValue
  },
  methods: {
    closeErrorSection() {
      this.showErrorSection = false
    },
    updateValue() {
      this.$emit('input', this.formValues)
    },
  },
  watch: {
    value(newValue) {
      this.formValues = newValue
    },
    formValues() {
      this.updateValue()
    },
    defaultValue(newValue) {
      this.formValues = newValue
    },
    errorsMap() {
      this.showErrorSection = true
    }
  }
}
</script>
